const translations = {
  cz: {
    hledat: 'Napiš, co hledáš. Např. švihadlo pro začátečníky',
    souvisejici: 'Ostatní Šviháci si ještě pořídili',
    NapsatHodnoceni: 'Napsat hodnocení',
    vybrat_variantu: 'Vybrat variantu',
    koupit: 'Přidat do košíku',
    vybratvariantu: 'Vybrat variantu',
    vKosiku: "Šviháku, díky. Máš to v košíku!",
    doporucujemePrikoupit: "Doporučujeme přikoupit",
    nakupniKosik: "Nákupní košík",
    uplatnitKod: "Uplatnit kód",
    jakZacitSeSvihadlem: "🏁 Jak začít se švihadlem",
    jakSiVybratSvihadlo: "💯 Jak vybrat švihadlo",
    kc: '0 Kč',
    zdarma: 'Zdarma',
    textreg: 'Chci založit účet a využívat všech výhod Šviháků',
    recenzi: 'recenzí',
    recenze: 'recenze',
    zanechtehodnoceni: 'Zanechte recenzi',
    odeslatrecenzi: 'Odeslat recenzi',
    pridatrecenzi: 'Přidat recenzi',

  },
  sk: {
    hledat: 'Napíš, čo hľadáš. Napr. švihadlo pre začiatočníkov',
    souvisejici: 'Ostatní Šviháci si ešte zaobstarali'
  }
};

function translation(key) {
  const lang = $('html').attr('lang') || 'cz';
  const parts = key.split('.');
  const requestedLang = parts.length > 1 ? parts[0] : lang;
  const realKey = parts.length > 1 ? parts[1] : parts[0];
  return translations[requestedLang] && translations[requestedLang][realKey]
    ? translations[requestedLang][realKey]
    : translations['cz'][realKey] || key;
}